<!--
 * @Author: wsx
 * @Date: 2022-02-23 17:00:48
 * @LastEditTime: 2022-02-11 17:52:34
 * @LastEditors: Please set LastEditors
 * @Description: 图片详情
 * @FilePath: \smart-community\src\components\global\HPicture.vue
-->
<template>
  <el-dialog
    v-model="formVisible"
    title="查看大图"
    width="60%"
    @close="closeDialog"
  >
    <div
      class="imageDialog"
      @mouseover="mouseInImg"
      @mouseout="mouseOutImg"
      @mousemove="mouseMoveImg"
    >
      <img class="imgDetialStyle" :src="url" />
      <div class="shadowimg"></div>
      <div class="bigimg">
        <img class="bigDetialStyle" :src="url" />
      </div>
    </div>
  </el-dialog>
</template>
<script>
import util from "@util/js";
import { ElMessage } from "element-plus";
import { defineComponent, reactive, toRefs, watchEffect } from "vue";
export default defineComponent({
  name: "HBigPicture",
  components: {},
  props: {
    pictureUrl: {
      type: String,
      default: "",
    },
    // 展示弹窗
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const state = reactive({
      formVisible: false,
      url: null,
      box: null,
      shadow: null,
      bigimg: null,
      bigimgTime: 300,
      imgE: null,
    });

    const refData = toRefs(state);
    // 使用wache监听不报红
    watchEffect(() => {
      state.formVisible = props.visible;
    });
    watchEffect(() => {
      state.url = props.pictureUrl;
    });
    const mouseInImg = () => {
      state.box = document.querySelector(".imgDetialStyle");
      state.shadow = document.querySelector(".shadowimg");
      state.bigimg = document.querySelector(".bigimg");
      state.big = document.querySelector(".bigDetialStyle");
      state.shadow.style.display = "block";
      state.big.style.display = "block";
    };
    const mouseOutImg = () => {
      state.shadow.style.display = "none";
      state.big.style.display = "none";
    };
    // const mouseWheelImg = (e) => {
    //   let big = document.querySelector(".bigDetialStyle");
    //   console.log(e.wheelDelta);
    //   if (e.wheelDelta == 120) {
    //     if (state.bigimgTime > 600) {
    //       util.debounceNow(() => {
    //         ElMessage.warning("已到图片最大倍数");
    //       }, 1000);
    //     } else {
    //       state.bigimgTime += 100;
    //       console.log(e);
    //       mouseMoveImg(state.imgE);
    //     }
    //   } else {
    //     if (state.bigimgTime < 300) {
    //       util.debounceNow(() => {
    //         ElMessage.warning("已到图片最小倍数");
    //       }, 1000);
    //     } else {
    //       state.bigimgTime -= 100;
    //       mouseMoveImg(state.imgE);
    //     }
    //   }
    //   big.style.width = state.bigimgTime + "%";
    //   big.style.height = state.bigimgTime + "%";
    // };
    const mouseMoveImg = (e) => {
      state.imgE = e;
      let x = state.imgE.pageX - state.box.offsetLeft - 390;
      let y = state.imgE.pageY - state.box.offsetTop - 190;
      let width = x - state.shadow.offsetWidth / 2;
      let height = y - state.shadow.offsetHeight / 2;
      if (width <= 0) {
        width = 0;
      } else if (width >= state.box.offsetWidth - state.shadow.offsetWidth) {
        width = state.box.offsetWidth - state.shadow.offsetWidth;
      }
      if (height <= 0) {
        height = 0;
      } else if (height >= state.box.offsetHeight - state.shadow.offsetHeight) {
        height = state.box.offsetHeight - state.shadow.offsetHeight;
      }
      state.shadow.style.left = width + "px";
      state.shadow.style.top = height + "px";
      let big = document.querySelector(".bigDetialStyle");
      let bigx =
        (width * (big.offsetWidth - state.bigimg.offsetWidth)) /
        (state.box.offsetWidth - state.shadow.offsetWidth);
      let bigy =
        (height * (big.offsetHeight - state.bigimg.offsetHeight)) /
        (state.box.offsetHeight - state.shadow.offsetHeight);
      big.style.left = -bigx + "px";
      big.style.top = -bigy + "px";
    };
    const closeDialog = () => {
      context.emit("update:visible", false);
      context.emit("closeBigPicture");
      state.url = null;
    };
    return {
      ...refData,
      mouseInImg,
      mouseOutImg,
      mouseMoveImg,
      closeDialog,
    };
  },
});
</script>
<style lang="scss" scoped>
.imageDialog {
  width: 100%;
  position: relative;
  z-index: 2000;
  @include flex-row-sb-c;
  .imgDetialStyle {
    width: 55%;
    height: 60vh;
  }
  .imgStyle {
    width: 100%;
    height: 100%;
  }
  .shadowimg {
    position: absolute;
    top: 0;
    left: 0;
    height: 123px;
    width: 125px;
    background: #333;
    opacity: 0.7;
    border: 1px solid #333;
    display: none;
  }
  .bigimg {
    border: 1px dashed;
    padding: 10px;
    height: 400px;
    width: 45%;
    overflow: hidden;
    margin-left: 10px;
    position: relative;
    .bigDetialStyle {
      display: none;
      width: 500%;
      height: 500%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>
